import React from 'react'
import "../nailcss/Bookingstepssection.css";

const steps = [
  {
    number: "1",
    title: "Tell us what you need",
    desc: "Select your service, city and preferred time.",
  },
  {
    number: "2",
    title: "We confirm the details",
    desc: "You receive the available slot and final estimated price.",
  },
  {
    number: "3",
    title: "Get the service at home",
    desc: "The artist arrives with the required products and tools.",
  },
];

function BookingStepsSection() {
  return (
    <section className="booksteps-section">
      <div className="booksteps-container">

        <div className="booksteps-left">
          <p className="booksteps-eyebrow">Simple Booking</p>
          <h2 className="booksteps-heading">Book in 3 easy steps</h2>
          <p className="booksteps-subtext">
            No app download, no long forms. Just tell us what you need and
            we'll take care of the rest.
          </p>
          <a href="#services" className="booksteps-btn">
            Book Service Now
          </a>
        </div>

        <div className="booksteps-right">
          {steps.map((step, index) => (
            <div className="booksteps-card" key={step.number}>
              <div className="booksteps-badge">{step.number}</div>
              <div className="booksteps-card-text">
                <h3 className="booksteps-card-title">{step.title}</h3>
                <p className="booksteps-card-desc">{step.desc}</p>
              </div>
              {index !== steps.length - 1 && (
                <span className="booksteps-connector"></span>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default BookingStepsSection
